var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('v-row',[_c('v-col',[_c('v-card',{staticClass:"px-5 py-2"},[_c('manage-organism-details')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }